export const characterTabs = [
  {
    key: "motive",
    label: "动机与欲望",
    title: "她想要什么",
    paragraphs: [
      "在原著与多数改编中，潘金莲的行为都围绕一个核心：摆脱被安排的处境。她先被卖作婢女，又被强行许配给武大郎，婚姻于她更像是一道无法选择的枷锁。",
      "正因如此，她对情感与出路的渴望往往表现得格外强烈。影视作品常借此展开她的心理线：与其说她追逐的是某个人，不如说她追逐的是“可以自己决定”的可能。",
    ],
    points: ["被安排的婚姻", "对自主的渴望", "欲望与生存交织"],
  },
  {
    key: "situation",
    label: "处境与压迫",
    title: "她被什么推着走",
    paragraphs: [
      "潘金莲的悲剧离不开她所处的结构：婢女身份、被转卖的命运、以男性为中心的家族秩序。把她的选择放回这些限制中，人物就不再是孤立的“恶”。",
      "许多改编会加重环境戏份——宅门里的等级、邻里的眼色、经济的依附——让观众看到一个人在有限选项中被一步步推向极端的过程。",
    ],
    points: ["身份与等级的束缚", "经济的依附关系", "邻里舆论的压力"],
  },
  {
    key: "symbol",
    label: "符号与争议",
    title: "她为何被反复讨论",
    paragraphs: [
      "长期以来，潘金莲被简化成一个“坏女人”的符号，承载着某种道德训诫。这种符号化的形象，也让改编者不断面临同一个问题：是延续它，还是拆解它。",
      "当影视作品试图表现她的处境与苦衷时，往往会引发“是否在替她开脱”的争论。争议本身说明，这个角色早已超出文本，成为一种关于性别与道德的社会话题。",
    ],
    points: ["道德符号的历史", "改编引发的争论", "文本之外的社会投射"],
  },
  {
    key: "reread",
    label: "女性视角重读",
    title: "换一种方式看她",
    paragraphs: [
      "近些年的写作与研究更倾向于从女性处境出发重读潘金莲：在一个人几乎没有婚姻自主权、也缺乏经济出路的时代，她的“反抗”是以扭曲的方式发生的。",
      "这种重读并不等于为她开脱，而是提醒读者区分“人物做了什么”与“制度允许她做什么”。影视改编若能同时呈现这两层，人物往往更立体、也更耐看。",
    ],
    points: ["处境先于评判", "反抗的扭曲形态", "更立体的改编空间"],
  },
];